

declare type PromiseObject<T> = { [K in keyof T]: Promise<T[K]> }

export { };



declare global {
    interface PromiseConstructor {
        fork<T>(objectPromise: PromiseObject<T>): Promise<T>;
    }
}

Promise.fork = function <T>(obj: PromiseObject<T>) {
    const promises = Object.keys(obj).map(key => obj[key as keyof T].then(value => ({ key, value })));
    return Promise.all(promises).then(array => {
        return array.reduce((obj, value) => Object.assign(obj, { [value.key]: value.value }), {}) as T
    });
}